import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// 숫자/코드용 mono 폰트 — OS 무관 동일 렌더링 (Windows에 SF Mono 없어 깨지던 문제)
import "@fontsource-variable/jetbrains-mono/index.css";

// 디자인 토큰 → 전역 reset → 컴포넌트 스타일 순서 (var() 정의 → 사용)
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/components.css";

import App from "./App";
import { installIosViewportFix } from "@/lib/iosViewportFix";
// 안드로이드 `beforeinstallprompt` 는 마운트 전에 올 수 있어 리스너를 먼저 건다(홈 화면 추가 안내)
import "@/lib/installPrompt";
import { AuthProvider } from "@/contexts/AuthContext";

// iOS 홈 화면 앱 뷰포트 높이 오차 보정(--vp-fix) — 렌더 전에 설치
installIosViewportFix();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);

// dev 전용: 미리보기에서 검사모드(Ctrl+Shift+⌘+C) → 클릭 → VS Code 소스로 점프.
// 프로덕션 빌드에는 이 동적 import가 dead-code로 제거됨.
if (import.meta.env.DEV) {
  import("@/dev/inspector").then((m) => m.mountInspector());
}
